import React, { useState, useEffect } from "react";
import Results from "./results";
import Register from "./register";
import Question from "./question";
import Completed from "./completed";
import ChallengeQuestion from "./challengeQuestion";
import Alias from "./alias";
import { useCurrentPage } from "../providers/CurrentPageContext";
import Countdown from "./countdown";
import { usePoints } from "../providers/PointsContext";

function Quiz() {
  const [currentPage, setCurrentPage] = useCurrentPage();
  const [points, setPoints] = usePoints();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [questions, setQuestions] = useState(null);
  const [gameId, setGameId] = useState(null);
  const [challengeQuestion, setChallengeQuestion] = useState(null);
  const [challengeQuestionAnswer, setChallengeQuestionAnswer] = useState(null);
  const [alias, setAlias] = useState("");
  const [saveAnswer, setSaveAnswer] = useState({});
  useEffect(() => {
    setCurrentPage(1);
    fetchQuestions();
  }, []);

  async function fetchQuestions() {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/questions`
      );
      const data = await response.json();
      setQuestions(data.questions);
      setGameId(data.session_id);
      setChallengeQuestion(data.challenge_questions);
      setPoints(0);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    currentPage === 1 && fetchQuestions();
  }, [currentPage]);

  /* useEffect(() => {
    if (challengeQuestionAnswer === null) return;
    const saveAnswerObject = saveAnswer;
    saveAnswerObject["quiz_challenge_answers"] = challengeQuestionAnswer;
    saveAnswerObject["quiz_challenge_id"] = challengeQuestion.id;
    saveAnswerObject["question_batch_id"] = questions[0].id;
    setSaveAnswer(saveAnswerObject);
    fetchResults();
  }, [challengeQuestionAnswer]);*/
  const answerChallengeQuestion = (answer) => {
    
    if (answer === null) return;

    setChallengeQuestionAnswer(answer);
    const saveAnswerObject = saveAnswer;
    saveAnswerObject["quiz_challenge_answers"] = challengeQuestionAnswer;
    saveAnswerObject["quiz_challenge_id"] = challengeQuestion.id;
    saveAnswerObject["question_batch_id"] = questions[0].id;
    setSaveAnswer(saveAnswerObject);
    fetchResults();
  };
  //Create method to fetch and save to setPoints
  const fetchResults = async () => {
    const score_result = await fetch(
      `${process.env.REACT_APP_API_URL}/validate`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(saveAnswer),
      }
    );
    const data = await score_result.json();
    setPoints(data);

    setCurrentPage(3);
  };
  const renderPage = () => {
    switch (currentPage) {
      case 1:
        return <Countdown />;
      case 2:
        return (
          <Question
            loading={loading}
            error={error}
            questions={questions}
            gameId={gameId}
            saveAnswer={saveAnswer}
            setSaveAnswer={setSaveAnswer}
            setChallengeQuestionAnswer={answerChallengeQuestion}
          />
        );
      /*case 3:
        return (
          <ChallengeQuestion
            question={challengeQuestion.question}
            setChallengeQuestionAnswer={answerChallengeQuestion}
          />
        );*/
      case 3:
        return <Results />;
      case 5:
        return <Register alias={alias} gameId={gameId} />;
      case 6:
        return <Completed />;
      default:
        return <div>Page not found</div>;
    }
  };

  return <div>{renderPage()}</div>;
}

export default Quiz;
